import { render, staticRenderFns } from "./BackofficeHonorarioMedico.vue?vue&type=template&id=15e127b0&scoped=true"
import script from "./BackofficeHonorarioMedico.vue?vue&type=script&lang=ts"
export * from "./BackofficeHonorarioMedico.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeHonorarioMedico.vue?vue&type=style&index=0&id=15e127b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e127b0",
  null
  
)

export default component.exports